
import validations from './validationFunctions';

let formValidation = (() => {

    let form = null;

    if (document.querySelector('[data-validation]')) {
        form = document.querySelector('form[data-validation]') ||
            document.querySelector('[data-validation]').closest('form') ||
            document.querySelector('[data-validation]').querySelector('form');
    }

    function warningValidation(input, messageSpan) {
        let warningMessage = '',
            validationResult = {
                valid: true,
                messages: []
            };

        for (let key in input.dataset) {
            if (validations[key]) {
                let inputValidation = validations[key](input.dataset[key], input.value);

                if (!inputValidation.valid) {
                    validationResult.valid = false;
                    validationResult.messages.push(inputValidation.message);
                }
            }
        }

        if (validationResult.valid && input) {
          input.classList.remove('warning-input', 'error-input');
            if (messageSpan) {
              messageSpan.innerHTML = '';
            }
            return;
        }

        input.classList.remove('error-input');
        input.classList.add('warning-input');
        validationResult.messages.forEach( message => {
            warningMessage += message + '. ';
        });

        if (messageSpan) {
            messageSpan.classList.remove('error-message');
            messageSpan.classList.add('warning-message');
            messageSpan.innerHTML = warningMessage;
        }
    }

    function submitForm(e) {
        form.querySelectorAll('input:not(.form__checkbox):not([class^="os-select2-"]), textarea').forEach( input => {
            warningValidation(input, input.nextSibling);
        });

        form.querySelectorAll('select').forEach(select => {
            let event = document.createEvent('Event');

            event.initEvent('change', true, true);
            select.dispatchEvent(event);
        });

        form.querySelectorAll('.form__checkbox-group[data-is-required]').forEach(group => {
            if (group.querySelectorAll(':checked').length === 0) {
                group.classList.add('error-input');
                return;
            }
            group.classList.remove('warning-input', 'error-input');
        });

        let warningInputs = form.querySelectorAll('.warning-input, .error-input'),
            warningMessages = form.querySelectorAll('.warning-message, .error-message');

      if (warningInputs.length > 0) {

           e.preventDefault();

            warningInputs.forEach(input => {
                input.classList.remove('warning-input');
                input.classList.add('error-input');
            });

            warningMessages.forEach(message => {
                message.classList.remove('warning-message');
                message.classList.add('error-message');
            });

            form.scrollIntoView();
        }
    }

    function getSelectParentSibling(select) {
        let msgParent,
            msgSibling;

        if (select.classList.contains('choices__input')) {
            msgParent = select.closest('.choices');
            msgSibling = msgParent.lastChild;
            return [msgParent, msgSibling];
        } else if (select.classList.contains('os-select-two-customers')) {
            msgParent = select.closest('div');
            msgSibling = msgParent.lastChild;
            return [msgParent, msgSibling];
        }

        msgParent = select.parentNode;
        msgSibling = select.nextSibling;

        return [msgParent, msgSibling];
    }

    function getSelectMsgSpan(select, msgParent, msgSibling) {
        let msgSpan;

        if(select.classList.contains('validation-select')){
            return msgParent.querySelector('.validation-message');
        }
        msgSpan = document.createElement('span');
        msgSpan.classList.add('validation-message');
        msgSpan.setAttribute('data-for', select.id);
        msgParent.insertBefore(msgSpan, msgSibling);
        return msgSpan;
    }

    function getInputMsgSpan(input) {
        let msgSpan;

        if (input.classList.contains('validation-input')) {
            return input.nextSibling;
        }

        msgSpan = document.createElement('span') ;
        msgSpan.classList.add('validation-message');
        msgSpan.setAttribute('data-for', input.id);
        input.parentNode.insertBefore(msgSpan, input.nextSibling);
        return msgSpan;
    }

    function validateForm() {
        if (form) {
            let inputs = form.querySelectorAll('input:not(.form__checkbox):not([class^="os-select2-"]), textarea'),
                selects = form.querySelectorAll('select'),
                checkboxGroup = form.querySelectorAll('.form__checkbox-group[data-is-required]');

            form.noValidate = true;

            inputs.forEach(input => {
                let messageSpan = getInputMsgSpan(input);

                input.classList.add('validation-input');
                input.addEventListener('input', () => {
                    warningValidation(input, messageSpan)
                });
            });

            selects.forEach(select => {
                let messageSpan,
                    messageParent,
                    messageSibling;

                [messageParent, messageSibling] = getSelectParentSibling(select);
                messageSpan = getSelectMsgSpan(select, messageParent, messageSibling);

                select.classList.add('validation-select');
                select.addEventListener('change', () => {
                    warningValidation(select, messageSpan);
                });
            });

            checkboxGroup.forEach(group => {
                if (group.dataset.isRequired) {
                    let checkboxes = group.querySelectorAll('.form__checkbox');

                    checkboxes.forEach(cb => {
                        cb.addEventListener('change', () => {
                            if (group.querySelectorAll(':checked').length === 0) {
                                group.classList.add('warning-input');
                                return;
                            }
                            group.classList.remove('warning-input', 'error-input');
                        })
                    })
                }
            });

            form.addEventListener('submit', (e) => {
                submitForm(e);
            });
        }
    }

    return {
        init: validateForm
    };
})();

$(document).ready( () => {
    formValidation.init();
});

export default formValidation;
